import styled from 'styled-components';

const Inline = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;

  p {
    margin: 1rem;
  }
`;

export default Inline;